module.exports = __webpack_public_path__ + "img/6f1.d049870f.jpg";